import { propClassName } from '@/styles/ArticleBodytext';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils';

export interface ArticleBodytextProps extends ComponentProps<'div'> {
  colors?: ClassNameProp;
  size?: ClassNameProp;
  variant?: ClassNameProp;
}

const ArticleBodytextComponent: Component<ArticleBodytextProps> = ({
  children,
  className,
  colors,
  size,
  variant,
  ...props
}) => {
  const colorsClassName = propClassName('colors', colors, 'default');
  const sizeClassName = propClassName('size', size, 'default');
  const variantClassName = propClassName('variant', variant, 'default');
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <div className={componentClassName} {...props}>
      {children}
    </div>
  );
};

export const ArticleBodytext = ArticleBodytextComponent;
